import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Pricing() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Pricing',
      price: '$9.99',
      period: '/year',
      note: 'one annual payment',
      access: '12 months of access',
      cta: 'Get CV Go App',
      guarantee: 'Secure payment via Stripe'
    },
    es: {
      title: 'Precio',
      price: '$9.99',
      period: '/año',
      note: 'pago anual único',
      access: '12 meses de acceso',
      cta: 'Comprar CV Go App',
      guarantee: 'Pago seguro vía Stripe'
    }
  };
  const t = content[language];
  return <section id="pricing" className="py-20 bg-white" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-lg mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-102">
          <div className="p-8 sm:p-10 text-center bg-gray-900 text-white" data-id="element-103">
            <h2 className="text-2xl font-bold mb-4" data-id="element-104">{t.title}</h2>
            <div className="flex justify-center items-baseline mb-2" data-id="element-105">
              <span className="text-5xl font-extrabold tracking-tight" data-id="element-106">
                {t.price}
              </span>
              <span className="text-xl text-gray-400 ml-2" data-id="element-107">{t.period}</span>
            </div>
            <p className="text-gray-400 font-medium" data-id="element-108">{t.note}</p>
          </div>

          <div className="p-8 sm:p-10 bg-white" data-id="element-109">
            <div className="flex items-center justify-center gap-3 mb-8" data-id="element-110">
              <div className="bg-green-100 p-1 rounded-full" data-id="element-111">
                <Check className="w-5 h-5 text-green-600" data-id="element-112" />
              </div>
              <span className="text-xl font-medium text-gray-900" data-id="element-113">
                {t.access}
              </span>
            </div>

            <a href="https://vitalrutinas.com/cart/53262378762608:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-8 bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 text-center" data-id="element-114">
              {t.cta}
            </a>

            <p className="mt-4 text-center text-sm text-gray-400" data-id="element-115">
              {t.guarantee}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}